<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      @if (filter) {
        <dx-form [formData]="filter" style="max-width: 400px">
          @if (filter) {
            <dxi-item [label]="{ text: 'Household' }">
              <div *dxTemplate>
                <dx-select-box
                  [(value)]="filter.householdId"
                  [items]="households"
                  valueExpr="id"
                  displayExpr="name"
                  (onValueChanged)="onValueChanged($event)"
                ></dx-select-box>
              </div>
            </dxi-item>
          }
        </dx-form>
      }
    </div>
  </div>
  <div class="grid-fill">
    <dx-data-grid
      #dataGrid
      [dataSource]="families"
      keyExpr="id"
      [wordWrapEnabled]="true"
      [rowAlternationEnabled]="false"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onRowPrepared)="rowPrepare($event)"
      [focusedRowEnabled]="false"
      >
      <dxi-column dataField="familyName" [width]="350" [sortIndex]="1" [sortOrder]="'asc'" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="status" caption="Status" [width]="200"></dxi-column>
      <dxi-column dataField="family.displayAddress" caption="Address" [width]="550"></dxi-column>
      <dxi-column dataField="homePhone" caption="Phone" [width]="200"></dxi-column>
      <!-- <dxi-column dataField="unlisted" caption="Unlisted" [width]="80"></dxi-column> -->
      <dxi-column dataField="lastVisit" format="shortDate" width="100px"></dxi-column>
      <dxi-column dataField="days" caption="Elapsed Days" width="150px"></dxi-column>
      <dxi-column dataField="isActive" caption="Active" [width]="80"></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        <a [routerLink]="" (click)="open(cell.data)">{{ cell.value || '(blank)' }}</a>
      </div>

      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-remote-operations [sorting]="true" [filtering]="true"></dxo-remote-operations>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="householdVisitGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button (click)="addVisit(dataGrid.instance.getSelectedRowsData()[0])" class="btn btn-primary" [disabled]="dataGrid.instance.getSelectedRowsData().length > 1" >
          Log Visit
        </button>
        <button
          (click)="quickVisit(dataGrid.instance.getSelectedRowsData())"
          class="ms-2 btn btn-danger"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Quick Log
        </button>
        <button (click)="addVisit(dataGrid.instance.getSelectedRowsData()[0])" class="ms-2 btn btn-secondary" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
          Open
        </button>
      </div>
    </dx-data-grid>
  </div>
</div>
